module.exports = __webpack_public_path__ + "img/active-a.ebf18b52.png";